import {Box, Typography} from '@mui/material';
import {Coffee} from 'lucide-react';
import React from 'react';
import {useBrandTheme} from '../useBrandTheme';

interface ChatCoffeeLogoProps {
  variant: `light` | `dark`;
}

export const ChatCoffeeLogo: React.FC<ChatCoffeeLogoProps> = ({variant}) => {
  const theme = useBrandTheme();

  const isLight = variant === `light`;

  return (
    <Box
      sx={{
        display: `flex`,
        alignItems: `center`,
        gap: 1,
        userSelect: `none`,
      }}
    >
      <Coffee
        size={20}
        style={{
          color: isLight ? theme.custom.colors.ui.white : theme.custom.colors.secondary,
          transform: `rotate(-15deg)`,
        }}
      />
      <Typography
        sx={{
          fontSize: `20px`,
          fontWeight: 700,
          ...(isLight
            ? {
                color: theme.custom.colors.ui.white,
                textShadow: `0 1px 3px rgba(0, 0, 0, 0.3)`,
              }
            : {
                background: `linear-gradient(135deg, ${theme.custom.colors.secondary} 0%, ${theme.custom.colors.secondaryLight} 50%, ${theme.custom.colors.primary} 100%)`,
                WebkitBackgroundClip: `text`,
                WebkitTextFillColor: `transparent`,
                backgroundClip: `text`,
              }),
          fontFamily: `"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif`,
          letterSpacing: `-0.5px`,
        }}
      >
        chat coffee
      </Typography>
    </Box>
  );
};
